/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { TreeNode } from '@ali-hm/angular-tree-component';

@Component({
  standalone: false,
  selector: 'gh-tree-node-wrapper',
  templateUrl: 'tree-node-wrapper.component.html',
  host: {
    'class': 'node-wrapper',
    '[style.padding-left]': 'node.getNodePadding()',
  },
})
export class TreeNodeWrapperComponent {
  @Input() node: TreeNode;
  @Input() index: number;
  @Input() templates: any;
}
